export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/NA-99674c14e9d8f0880119acb3b392a390.png";